import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import AnimationClip from '../AnimationClip';

export class PlayerIconShadowIdle extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const renderable: Renderable = gameObject.getComponent(Renderable);

        const shadowTweenIn = this.getTween(renderable);
        const shadowTweenOut = this.getTween(renderable);

        shadowTweenIn.to({ alpha: 0.8 }, 300).easing(Easing.Quadratic.Out);
        shadowTweenOut.to({ alpha: 1 }, 500).easing(Easing.Bounce.Out);
        shadowTweenIn.chain(shadowTweenOut);
        shadowTweenOut.chain(shadowTweenIn);

        shadowTweenIn.delay(3000).start(this.elapsedTime);

        while (true) yield;
    }
}
